import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Layout } from './components/Layout';
import { RequireAuth } from './auth/RequireAuth';
import { RequireAdmin } from './auth/RequireAdmin';
import { HomePage } from './pages/HomePage';
import { ProductPage } from './pages/ProductPage';
import { CartPage } from './pages/CartPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { OrderPage } from './pages/OrderPage';
import { LibraryPage } from './pages/LibraryPage';
import { CoursePlayerPage } from './pages/CoursePlayerPage';
import { WorkshopPage } from './pages/WorkshopPage';
import { LoginPage } from './pages/LoginPage';
import { RedeemPage } from './pages/RedeemPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { AdminHomepageSettingsPage } from './pages/AdminHomepageSettingsPage';
import { AdminDashboardLayout } from './components/admin/AdminDashboardLayout';
import { AdminOverviewPage } from './pages/admin/AdminOverviewPage';
import { AdminProductsPage } from './pages/admin/AdminProductsPage';
import { AdminStudentsPage } from './pages/admin/AdminStudentsPage';
import { AdminCouponsPage } from './pages/admin/AdminCouponsPage';
import { AdminActivationCodesPage } from './pages/admin/AdminActivationCodesPage';
import { AdminOrdersPage } from './pages/admin/AdminOrdersPage';
import { AdminWorkshopsPage } from './pages/admin/AdminWorkshopsPage';
import { LegalPage } from './pages/LegalPage';

export function App() {
  const location = useLocation();

  if (location.pathname === '/admin' || location.pathname.startsWith('/admin/')) {
    return (
      <Routes>
        <Route
          path="/admin"
          element={
            <RequireAuth>
              <RequireAdmin>
                <AdminDashboardLayout />
              </RequireAdmin>
            </RequireAuth>
          }
        >
          <Route index element={<AdminOverviewPage />} />
          <Route path="khoa-hoc" element={<AdminProductsPage />} />
          <Route path="don-hang" element={<AdminOrdersPage />} />
          <Route path="hoc-vien" element={<AdminStudentsPage />} />
          <Route path="workshop" element={<AdminWorkshopsPage />} />
          <Route path="trang-chu" element={<AdminHomepageSettingsPage />} />
          <Route path="voucher" element={<AdminCouponsPage />} />
          <Route path="ma-kich-hoat" element={<AdminActivationCodesPage />} />
          <Route path="cai-dat-trang-chu" element={<Navigate to="/admin/trang-chu" replace />} />
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Route>
      </Routes>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/san-pham/:slug" element={<ProductPage />} />
        <Route path="/workshop/:slug" element={<WorkshopPage />} />
        <Route path="/dang-nhap" element={<LoginPage />} />
        <Route path="/dieu-khoan" element={<LegalPage kind="terms" />} />
        <Route path="/quyen-rieng-tu" element={<LegalPage kind="privacy" />} />
        <Route path="/chinh-sach-hoan-tien" element={<LegalPage kind="refund" />} />
        <Route
          path="/gio-hang"
          element={
            <RequireAuth>
              <CartPage />
            </RequireAuth>
          }
        />
        <Route
          path="/thanh-toan"
          element={
            <RequireAuth>
              <CheckoutPage />
            </RequireAuth>
          }
        />
        <Route
          path="/don-hang/:orderId"
          element={
            <RequireAuth>
              <OrderPage />
            </RequireAuth>
          }
        />
        <Route
          path="/thu-vien"
          element={
            <RequireAuth>
              <LibraryPage />
            </RequireAuth>
          }
        />
        <Route
          path="/hoc/:slug"
          element={
            <RequireAuth>
              <CoursePlayerPage />
            </RequireAuth>
          }
        />
        <Route
          path="/kich-hoat"
          element={
            <RequireAuth>
              <RedeemPage />
            </RequireAuth>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Layout>
  );
}
